import React from "react"
import ReactPlayer from 'react-player'
import { translate } from "../../utils/language"
import { renderMarkdown } from "../../utils/rendermarkdown"


export const BlogpostExternerInhaltMitText = ({data, language}) => {
    return <div>
        <div className="externer-inhalt-text-container">
            <p className="externer-inhalt-text-text">{renderMarkdown(translate(language, data.Deutsch, data.Englisch))}</p>
            <ReactPlayer className="externer-inhalt-text-player" controls={true} url={data.URL}/>
        </div>
    </div>
    }
